import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../state/hooks";
import { fetchProjectDiagram } from "../state/slices/systemSlice";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faExpand, faCompress, faPuzzlePiece, faArrowsToDot} from "@fortawesome/free-solid-svg-icons";
import { selectCurrentProject, selectCurrentProjectName } from "../state/slices/systemSlice";
import { localconsole } from "../App";
import { selectAssemblyComps, selectAssemblyShips, selectCurrentAssembly } from "../state/slices/assemblySlice";
import { selectShowAssembly, toggleShowAssembly, selectCurrentDiagram } from "../state/slices/uiSlice";
//import { app_version } from "../state/localStorage";

interface DiagramProps {
    isExpanded: boolean,
    setFormsVisible: Dispatch<SetStateAction<boolean>>
}


function Diagram(props: DiagramProps) {

  const currentProjectName = useAppSelector(state => selectCurrentProjectName(state));
  const currentProject = useAppSelector(state => selectCurrentProject(state));
    const currentAssembly = useAppSelector(state => selectCurrentAssembly(state));

    const currentAssemblyComps = useAppSelector(state => selectAssemblyComps(state))
    const currentAssemblyShips = useAppSelector(state => selectAssemblyShips(state))

  const isShowAssembly = useAppSelector(state => selectShowAssembly(state))
  const diagramSVG = useAppSelector(state => selectCurrentDiagram(state))

    const components = () => isShowAssembly ? currentAssemblyComps : currentProject.components
    const ships = () => isShowAssembly ? currentAssemblyShips : currentProject.ships
    const options = () => isShowAssembly ? currentAssembly.options : currentProject.options  //TODO, allow options for assemblies
    const colors = () => isShowAssembly ? currentAssembly.colors : currentProject.colors
    const dispatch = useAppDispatch()


    //const [diagramSVG, setDiagramSVG] = useState<string>("");


  //get the diagram by calling the state thunk which will check the cache before calling backend, add fonts etc
//TODO, basically a copy of this for assembly
  /*
  useEffect(() => {
    if (!currentProjectName || !currentProject.diagramHash) return;
    localconsole("Fetching current project diagram");
    const fetchData = async () => {
            const action = await dispatch(fetchProjectDiagram({ projectName: currentProjectName }));

            // Check if the action was fulfilled
      //if (fetchProjectDiagram.fulfilled.match(action) && action.payload !== "") {
      //           action.payload contains the returned value (the SVG string)
      //          setDiagramSVG(action.payload as string);
      //      }
        };

        fetchData();

  }, [dispatch, currentProjectName, currentProject.diagramHash]);
  */
  //  let inFlightAC = new AbortController()
  //  let inFlightDelay = setTimeout(() => {return Promise.resolve(false)}, 1)

  return (
      <div className={"box content"}>
        <div className="buttons has-addons is-right">


          <div className={"control"}>
              <button className={"button"}
                onClick={() => dispatch(toggleShowAssembly())}
                aria-label={isShowAssembly ? "show project" : "show assembly"}
                title={isShowAssembly ? "Show Project Diagram" : "Show Assembly Diagram"}
              >
                        <span className={"icon"}>
                            {(isShowAssembly) ? <FontAwesomeIcon icon={faPuzzlePiece}/> :
                                <FontAwesomeIcon icon={faArrowsToDot}/>}
                        </span>
              </button>
          </div>

          <div className={"control"}>
              <button className={"button"}
                onClick={() => props.setFormsVisible(props.isExpanded)}
                aria-label={props.isExpanded ? "shrink diagram" : "expand diagram"}
                title={props.isExpanded ? "Shrink Diagram" : "Expand Diagram"}
              >
                        <span className={"icon"}>
                            {(props.isExpanded) ? <FontAwesomeIcon icon={faCompress}/> :
                                <FontAwesomeIcon icon={faExpand}/>}
                        </span>
              </button>
          </div>

        </div>
          {/* Could use style={{mixBlendMode: "multiply"}} here to get rid of white background but currently prefer the white box*/}
          <figure className="image" style={{marginLeft: "auto", marginRight: "auto"}}>
            {((diagramSVG === undefined || diagramSVG === "") ) ?
                  <img src="berd_placeholder.svg" alt="Placeholder berd diagram"></img>
                  :
                  <img src={"data:image/svg+xml," + diagramSVG} alt="berd diagram"></img>}
          </figure>


      </div>
  );
}

export default Diagram;
